var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUzbekistan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:54025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7555 11.5494C0.265375 13.0849 -6.2489e-05 14.7207 1.10347e-08 16.4188C-6.2489e-05 18.1169 0.265437 19.7529 0.755562 21.2884L16 21.9841L31.2444 21.2885C31.7345 19.7529 32.0001 18.1169 32.0001 16.4189C32 14.7208 31.7346 13.0849 31.2444 11.5494L16 10.8537L0.7555 11.5494Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2444 11.5494L16 10.8538L0.755496 11.5494C0.610246 12.0047 0.485184 12.4689 0.380371 12.9407H31.6194C31.5147 12.4688 31.3897 12.0046 31.2444 11.5494Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.380615 19.8968C0.485303 20.3687 0.610365 20.8328 0.755615 21.288L0.757115 21.2881L16 21.9837L31.2444 21.2881C31.3897 20.8329 31.5147 20.3687 31.6195 19.8968H0.380615Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4188C23.1385 32.4188 29.1841 27.7436 31.2444 21.2883H0.755615C2.81593 27.7435 8.86168 32.4188 16 32.4188V32.4188Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0.419029C8.86168 0.419092 2.81605 5.09428 0.755615 11.5495L31.2444 11.5495C29.1842 5.09422 23.1386 0.418967 16.0001 0.419029V0.419029Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31208 7.02742C7.31208 5.52886 8.36527 4.27699 9.7717 3.96986C9.55558 3.92261 9.33126 3.89705 9.10089 3.89705C7.37202 3.89705 5.97046 5.29855 5.97046 7.02748C5.97046 8.75642 7.37189 10.1579 9.10089 10.1579C9.33126 10.1579 9.55551 10.1323 9.7717 10.0851C8.36533 9.77785 7.31208 8.52598 7.31208 7.02742V7.02742Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6224 8.44989L11.8342 9.10208H12.52L11.9652 9.5052L12.1771 10.1574L11.6224 9.75433L11.0675 10.1574L11.2794 9.5052L10.7246 9.10208H11.4104L11.6224 8.44989Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8107 8.44989L14.0226 9.10208H14.7084L14.1536 9.5052L14.3655 10.1574L13.8107 9.75433L13.2559 10.1574L13.4678 9.5052L12.9131 9.10208H13.5988L13.8107 8.44989Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 8.44989L16.2117 9.10208H16.8975L16.3427 9.5052L16.5546 10.1574L15.9998 9.75433L15.4449 10.1574L15.6569 9.5052L15.1021 9.10208H15.7879L15.9998 8.44989Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1883 8.44989L18.4002 9.10208H19.0859L18.5312 9.5052L18.7431 10.1574L18.1883 9.75433L17.6334 10.1574L17.8454 9.5052L17.2905 9.10208H17.9763L18.1883 8.44989Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3776 8.44989L20.5895 9.10208H21.2753L20.7205 9.5052L20.9325 10.1574L20.3776 9.75433L19.8228 10.1574L20.0347 9.5052L19.48 9.10208H20.1657L20.3776 8.44989Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8107 6.17389L14.0226 6.82601H14.7084L14.1536 7.2292L14.3655 7.88133L13.8107 7.47826L13.2559 7.88133L13.4678 7.2292L12.9131 6.82601H13.5988L13.8107 6.17389Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 6.17389L16.2117 6.82601H16.8975L16.3427 7.2292L16.5546 7.88133L15.9998 7.47826L15.4449 7.88133L15.6569 7.2292L15.1021 6.82601H15.7879L15.9998 6.17389Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1883 6.17389L18.4002 6.82601H19.0859L18.5312 7.2292L18.7431 7.88133L18.1883 7.47826L17.6334 7.88133L17.8454 7.2292L17.2905 6.82601H17.9763L18.1883 6.17389Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3776 6.17389L20.5895 6.82601H21.2753L20.7205 7.2292L20.9325 7.88133L20.3776 7.47826L19.8228 7.88133L20.0347 7.2292L19.48 6.82601H20.1657L20.3776 6.17389Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 3.89688L16.2117 4.54913H16.8975L16.3427 4.95219L16.5546 5.60444L15.9998 5.20138L15.4449 5.60444L15.6569 4.95219L15.1021 4.54913H15.7879L15.9998 3.89688Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1883 3.89688L18.4002 4.54913H19.0859L18.5312 4.95219L18.7431 5.60444L18.1883 5.20138L17.6334 5.60444L17.8454 4.95219L17.2905 4.54913H17.9763L18.1883 3.89688Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3776 3.89688L20.5895 4.54913H21.2753L20.7205 4.95219L20.9325 5.60444L20.3776 5.20138L19.8228 5.60444L20.0347 4.95219L19.48 4.54913H20.1657L20.3776 3.89688Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:54025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.418945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzbekistan);
export default __webpack_public_path__ + "static/media/uzbekistan.7ed205f6.svg";
export { ForwardRef as ReactComponent };